import { Box, useRecipe } from '@chakra-ui/react';
import {
  useMemo,
  Children,
  cloneElement,
  isValidElement,
  type JSX,
  type ReactNode,
  type ComponentProps,
} from 'react';

import { quoteRecipe } from './recipe';

export function Quote({ children }: ComponentProps<'blockquote'>): JSX.Element {
  const content = useMemo(() => {
    return Children.toArray(children).map((child) => {
      if (isValidElement(child)) {
        return cloneElement(
          child,
          {},
          Children.toArray((child as TAny).props.children).reduce<
            Exclude<ReactNode, boolean | null | undefined>[]
          >((result, child) => {
            if (isValidElement(child)) {
              result.push(cloneElement(child));
            }

            if (typeof child === 'string' && child.trim()) {
              result.push(child);
            }

            return result;
          }, []),
        );
      }

      return child;
    });
  }, [children]);

  const recipe = useRecipe({
    recipe: quoteRecipe,
  });

  const styles = recipe();

  return (
    <Box css={styles} as='blockquote'>
      {content}
    </Box>
  );
}
